/* eslint-disable no-throw-literal */
const init = () => {
  const pageHost = window.location.host;

  const storageSyncHandler = (data) => {
    let responseStatus;
    const { type, storage, payload } = data;
    if (!payload) return;

    const cookieStorageHandler = (type, payload) => {
      const insertOrUpdateOne = (payload) => {
        const {
          name,
          value = '',
          expires = '',
          path = '/',
          host = pageHost
        } = payload;
        if (!name) return;
        document.cookie = `${name}=${value};expires=${expires};host=${host};path=${path};samesite=none;secure;`;
      };
      const removeOne = (payload) => {
        const {
          name,
          value = '',
          maxAge = '-1',
          path = '/',
          host = pageHost
        } = payload;
        if (!name) return;
        document.cookie = `${name}=${value};max-age=${maxAge};path=${path};samesite=none;secure;`;
        document.cookie = `${name}=${value};max-age=${maxAge};host=${host};path=${path};samesite=none;secure;`;
        document.cookie = `${name}=${value};max-age=${maxAge};host=.${host};path=${path};samesite=none;secure;`;
      };
      const insertOrUpdateBulk = (payload) => payload.forEach((record) => insertOrUpdateOne(record));
      // const removeBulk = (payload) => {
      // };
      // const findOne = (payload) => {
      // };
      // const getAll = (payload) => {
      // };
      // const removeAll = (payload) => {
      // };

      const typeMap = {
        INSERT_OR_UPDATE_ONE: insertOrUpdateOne,
        REMOVE_ONE: removeOne,
        INSERT_OR_UPDATE_BULK: insertOrUpdateBulk
        // REMOVE_BULK: removeBulk,
        // FIND_ONE: findOne,
        // GET_ALL: getAll,
        // REMOVE_ALL: removeAll
      };

      if (!typeMap[type]) return 'INVALID - REQUEST';
      typeMap[type](payload);
    };

    const localStorageHandler = (type, payload) => {
      const insertOrUpdateOne = (payload) => {
        const { name, value = '' } = payload;
        if (!name) return;
        localStorage.setItem(name, value);
      };
      const removeOne = (payload) => {
        const { name } = payload;
        if (!name) return;
        localStorage.removeItem(name);
      };
      const insertOrUpdateBulk = (payload) => payload.forEach((record) => insertOrUpdateOne(record));
      // const removeBulk = (payload) => {
      // };
      // const findOne = (payload) => {
      // };
      // const getAll = (payload) => {
      // };
      // const removeAll = (payload) => {
      // };

      const typeMap = {
        INSERT_OR_UPDATE_ONE: insertOrUpdateOne,
        REMOVE_ONE: removeOne,
        INSERT_OR_UPDATE_BULK: insertOrUpdateBulk
        // REMOVE_BULK: removeBulk,
        // FIND_ONE: findOne,
        // GET_ALL: getAll,
        // REMOVE_ALL: removeAll
      };

      if (!typeMap[type]) return 'INVALID - REQUEST';
      typeMap[type](payload);
    };

    switch (storage) {
      case 'COOKIE_STORAGE': {
        responseStatus = cookieStorageHandler(type, payload);
        break;
      }
      case 'LOCAL_STORAGE': {
        responseStatus = localStorageHandler(type, payload);
        break;
      }
      default: {
        responseStatus = 'INVALID - STORAGE';
        break;
      }
    }
    return responseStatus;
  };

  const messageHandler = (e) => {
    if (!e) return;
    const { origin, data } = e;
    const parsedData = data ? (typeof data === 'string' ? JSON.parse(data) : data) : {};
    let responseStatus;

    const requestValidator = (origin) => {
      const allowedOrigins = [
        'https://www.freshworks.com',
        'https://freshdesk.com',
        'https://freshservice.com'
      ];
      if (!allowedOrigins.includes(origin)) return 'FORBIDDEN ORIGIN';
    };

    const requestHandlerPath = (parsedData) => {
      const { channel } = parsedData;
      let responseStatus;
      switch (channel) {
        case 'CROSS_DOMAIN_STORAGE_SYNC': {
          responseStatus = storageSyncHandler(parsedData);
          break;
        }
        default: {
          responseStatus = 'INVALID - CHANNEL';
          break;
        }
      }
      return responseStatus;
    };

    const responseHandler = (errMessage) => '';

    try {
      responseStatus = requestValidator(origin);
      if (responseStatus) return responseHandler(responseStatus);

      responseStatus = requestHandlerPath(parsedData);
      if (responseStatus) return responseHandler(responseStatus);

      return responseHandler();
    } catch (err) {
      return responseHandler(err);
    }
  };

  window.addEventListener('message', messageHandler, false);
};

init();
